import React from 'react';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import {
  handlePostLogin,
  getRememberMe,
  addImpersonateUser,
  getAuthUser,
  deleteImpersonateUser,
} from '../../../utils/auth.util';

import './ImpersonateTabs.scss';

export default function ImpersonateTabs({ users, changeEmployeeMutation }) {
  // Function to handle employee change
  const handleEmployeeChange = async employee => {
    if (employee?.selected) return;
    const resp = await changeEmployeeMutation.mutateAsync({
      employeeNo: employee?.employeeId,
    });
    addImpersonateUser({
      employeeId: employee?.employeeId,
      userName: employee?.userName,
    });
    handlePostLogin(resp?.data, '/dashboard', getRememberMe() || false);
  };

  // Function to handle employee deletion
  const handleEmployeeDelete = async employee => {
    deleteImpersonateUser(employee);
    if (employee?.selected) {
      const resp = await changeEmployeeMutation.mutateAsync({
        employeeNo: getAuthUser()?.userName.trim().toLowerCase(),
      });
      handlePostLogin(resp?.data, '/dashboard', getRememberMe() || false);
    }
  };

  if (!users || users.length === 0) return null;

  return (
    <div className="impersonate-users-tabs">
      {users.map(user => (
        <div
          key={user.employeeId}
          className={`impersonate-user-tab d-flex justify-content-between align-items-center ${user.selected ? 'active' : ''}`}
          onClick={() => handleEmployeeChange(user)}
        >
          <span className="id">
            {user.userName}, {user?.employeeId?.toUpperCase()}
          </span>
          {user?.employeeId !== getAuthUser()?.userName.trim().toLowerCase() &&
            user?.selected && (
              <span
                className="delete-icon"
                onClick={e => {
                  e.stopPropagation();
                  handleEmployeeDelete(user);
                }}
              >
                <Icon path={mdiClose} size={0.7} />
              </span>
            )}
        </div>
      ))}
    </div>
  );
}
